import { types } from "mobx-state-tree"

const Checkpoint = types.model('Checkpoint', {
    id: types.identifierNumber,
    name: types.string,
    position: types.integer,
})

export default Checkpoint
